import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MaxioCustomer } from '../interfaces/maxioCustomerInfo';

@Injectable({
  providedIn: 'root',
})
/* istanbul ignore next */
export class MaxioCustomerService {
  // Holds the current customer ID or null if none
  private readonly customerIdSubject = new BehaviorSubject<number | null>(null);

  // Holds the full customer data or null if none
  private readonly customerDataSubject = new BehaviorSubject<MaxioCustomer | null>(null);

  // Observable for components to subscribe to
  /* istanbul ignore next */
  customerId$: Observable<number | null> =
    this.customerIdSubject.asObservable();

  /* istanbul ignore next */
  customerData$: Observable<MaxioCustomer | null> =
    this.customerDataSubject.asObservable();

  constructor() {}

  // Setter to update the stored customer ID
  /* istanbul ignore next */
  setCustomerId(id: number | null): void {
    this.customerIdSubject.next(id);
  }

  // Setter to update the stored customer data
  /* istanbul ignore next */
  setCustomerData(data: MaxioCustomer | null): void {
    this.customerDataSubject.next(data);
    // Also update the customer ID when setting customer data
    if (data) {
      this.customerIdSubject.next(data.customer_id);
    } else {
      this.customerIdSubject.next(null);
    }
  }

  // Getter to get the current value synchronously
  /* istanbul ignore next */
  get currentCustomerId(): number | null {
    return this.customerIdSubject.value;
  }

  // Getter to get the current customer data synchronously
  /* istanbul ignore next */
  get currentCustomerData(): MaxioCustomer | null {
    return this.customerDataSubject.value;
  }
}
